import { ORIGINS, chooseOrigin, type PlayerProgress } from '@nine/shared';
import '../loading/loading.css';
import { h } from './dom';

/**
 * Origin picker for a NEW character, shown before the opening: four `.ls-card` cards (the liked frame).
 * A is playable; B-D show "เร็ว ๆ นี้" until their `ready` flag flips. Calls `done` once an origin is stored.
 */
export function pickOrigin(pr: PlayerProgress, done: () => void): void {
  const wrap = h('div', {});
  wrap.style.cssText =
    'position:fixed;inset:0;z-index:9999;display:flex;flex-wrap:wrap;gap:16px;align-items:center;justify-content:center;background:rgba(10,10,12,.82);padding:24px;overflow:auto';
  const cards = ORIGINS.map((o) => {
    const card = h(
      'div',
      { class: 'ls-card' },
      h('div', { class: 'ls-dest' }, o.name),
      h('p', {}, o.town),
      h('p', {}, o.pitch),
      o.ready
        ? h('button', { type: 'button', class: 'btn' }, 'เริ่มเรื่องนี้')
        : h('p', {}, 'เร็ว ๆ นี้'),
    );
    card.style.cssText = 'position:static;right:auto;bottom:auto;width:230px;' + (o.ready ? '' : 'opacity:.55');
    if (o.ready) {
      card.querySelector('button')!.addEventListener('click', () => {
        if (!chooseOrigin(pr, o.id)) return;
        wrap.remove();
        done();
      });
    }
    return card;
  });
  wrap.append(...cards);
  document.body.append(wrap);
}
